import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Article = function Article(_ref) {
  var element = _ref.element,
      children = _ref.children,
      className = _ref.className,
      label = _ref.label,
      labelledby = _ref.labelledby,
      rest = _objectWithoutPropertiesLoose(_ref, ["element", "children", "className", "label", "labelledby"]);

  var Element = element;
  return /*#__PURE__*/React.createElement(Element, _extends({}, rest, {
    className: classnames(className, 'ln-o-article'),
    "aria-label": label,
    "aria-labelledby": labelledby
  }), children);
};

Article.propTypes = {
  /** Allows the top-level element to be customized */
  element: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
  children: PropTypes.node,
  className: PropTypes.string,

  /** Short description of the article to allow screen readers to use the component as a region */
  label: PropTypes.string,

  /** ID of element with text content describing the article to allow screen readers to use the component as a region */
  labelledby: PropTypes.string
};
Article.defaultProps = {
  element: 'article',
  children: undefined,
  className: undefined,
  label: undefined,
  labelledby: undefined
};
Article.displayName = 'Article';

var Main = function Main(_ref) {
  var element = _ref.element,
      children = _ref.children,
      className = _ref.className,
      id = _ref.id,
      label = _ref.label,
      labelledby = _ref.labelledby,
      rest = _objectWithoutPropertiesLoose(_ref, ["element", "children", "className", "id", "label", "labelledby"]);

  var Element = element;
  return /*#__PURE__*/React.createElement(Element, _extends({}, rest, {
    className: className,
    id: id,
    role: "main",
    "aria-label": label,
    "aria-labelledby": labelledby
  }), children);
};

Main.propTypes = {
  /** Allows the top-level element to be customized */
  element: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
  children: PropTypes.node,
  className: PropTypes.string,

  /** ID used by skip links for screen readers to jump to content */
  id: PropTypes.string,

  /** Short description of the content to give additional context to screen readers */
  label: PropTypes.string,

  /** ID of element containing text describing the content to give additional context to screen readers */
  labelledby: PropTypes.string
};
Main.defaultProps = {
  element: 'main',
  children: undefined,
  className: undefined,
  id: 'main-content',
  label: undefined,
  labelledby: undefined
};
Main.displayName = 'Main';

var Section = function Section(_ref) {
  var element = _ref.element,
      children = _ref.children,
      className = _ref.className,
      soft = _ref.soft,
      label = _ref.label,
      labelledby = _ref.labelledby,
      rest = _objectWithoutPropertiesLoose(_ref, ["element", "children", "className", "soft", "label", "labelledby"]);

  var Element = element;
  return /*#__PURE__*/React.createElement(Element, _extends({}, rest, {
    className: classnames('ln-o-section', soft && "ln-o-section--" + soft, className),
    "aria-label": label,
    "aria-labelledby": labelledby
  }), children);
};

Section.propTypes = {
  /** Allows the top-level element to be customized */
  element: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
  children: PropTypes.node,
  className: PropTypes.string,

  /** Sets size of spacing below section based on `$ln-section-soft-variants` variable */
  soft: PropTypes.string,

  /** Short description of the section to allow screen readers to use the component as a region */
  label: PropTypes.string,

  /** ID of element with text content describing the section to allow screen readers to use the component as a region */
  labelledby: PropTypes.string
};
Section.defaultProps = {
  element: 'section',
  children: undefined,
  className: undefined,
  soft: undefined,
  label: undefined,
  labelledby: undefined
};
Section.displayName = 'Section';
export { Article, Main, Section };